import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import MainContent from './MainContent';
import { CrackersProvider } from "./CrackersContext";
import { BrowserRouter as Router } from 'react-router-dom';
import InterceptorSetup from './InterceptorSetup';

import bg from './images/bg.png'

function App() {
  return (
    // <div style={{ backgroundImage: `url(${bg})`, height: "100vh" }}>
      <CrackersProvider>
        <Router>
          <InterceptorSetup />
          <MainContent />
        </Router>
      </CrackersProvider>
    // </div>
    
  );
}

export default App;
